export enum PaymentDeviceType {
    IOS = "IOS",
    ANDROID = "ANDROID",
    LK_AUTHORIZED = "LK_AUTHORIZED",
}


// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/models/payment-device-type.ts